import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TableVirtualizer } from '../TableVirtualizer';
import { configureColumnDefs, convertToRowData } from './helper';
export function ModulesDependencies(param) {
    let { organization, project, appList = [] } = param;
    const columnDefs = useMemo(()=>configureColumnDefs(appList, organization, project), [
        appList,
        organization,
        project
    ]);
    const rowData = useMemo(()=>convertToRowData(appList, organization), [
        appList,
        organization
    ]);
    const pinnedColumns = useMemo(()=>{
        return {
            left: [
                'moduleName'
            ],
            right: [
                'moduleRequires'
            ]
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "h-[calc(100vh-320px)] overflow-auto rounded-lg",
        children: /*#__PURE__*/ _jsx(TableVirtualizer, {
            data: rowData,
            columns: columnDefs,
            pinnedColumns: pinnedColumns
        })
    });
}
// Export renderers for reuse in other components
export { ModuleDependencyRenderer } from './renderers/ModuleDependencyRenderer';
export { ModuleOrApplicationLinkRenderer } from './renderers/ModuleOrApplicationLinkRenderer';
export { TagsRenderer } from './renderers/TagsRenderer';
